import { Form, FormInstance } from 'antd';

type UseSkillModalFormParametersType<T> = {
  onSubmit?: (values: T) => Promise<void>;
};
type UseSkillModalFormReturnType = {
  form: FormInstance;
  submit: () => Promise<void>;
};
export const useForm = <T>(
  params?: UseSkillModalFormParametersType<T>,
): UseSkillModalFormReturnType => {
  const [form] = Form.useForm<T>();
  const submit = async (): Promise<void> => {
    if (params?.onSubmit) {
      await params.onSubmit(form.getFieldsValue(true) as T);
    }
  };

  return {
    form,
    submit,
  };
};
